import React from "react";
import UnclaimButton from "@components/FlowActionButtons/UnclaimButton";
import { canUserUnclaim, type DeficiencyFlowData } from "./utils";

interface UnclaimDeficiencyProps {
  deficiencyFlowData?: DeficiencyFlowData;
  onUnclaim?: () => void;
}

const LANG_BASE = "deficiencies";

const UnclaimDeficiency: React.FC<UnclaimDeficiencyProps> = ({
  deficiencyFlowData,
  onUnclaim = () => {},
}) => {
  if (!deficiencyFlowData?.task) {
    return null;
  }

  const isActionAvailable = canUserUnclaim(
    deficiencyFlowData.task.status,
    deficiencyFlowData.task.claimOwnerName,
    deficiencyFlowData.status,
  );

  return (
    <UnclaimButton
      langBase={LANG_BASE}
      permission="canUnclaimFottDeficiency"
      isActionAvailable={isActionAvailable}
      onUnclaim={onUnclaim}
    />
  );
};

export default UnclaimDeficiency;
